import type { NextPage } from 'next';
import { useMarketplaceProjects } from '@hooks/useMarketplaceProjects';
import { Nav } from '@components/Nav';
import { LoadingContent } from '@components/LoadingContent';
import { Container } from '@components/home/Container';
import { Marketplace } from '@components/Marketplace';

const MarketplacePage: NextPage = () => {
  const { data, error, isValidating } = useMarketplaceProjects();

  return (
    <div>
      <div className="relative z-20">
        <Nav coloredBorder transparentBackground />
      </div>
      <Container>
        <LoadingContent loading={isValidating && !data} error={error}>
          <div className="pb-20">
            <Marketplace />
          </div>
        </LoadingContent>
      </Container>
    </div>
  );
};

export default MarketplacePage;
